import type { AffineDNDEntity } from '@affine/core/types/dnd';

type NavigationPanelTrashCapabilityItem = {
  docTrash?: {
    canTrashDoc: boolean;
  };
  entity: AffineDNDEntity;
  folderTrash?: {
    canTrashFolder: boolean;
  };
};

type NavigationPanelTrashableSelectionItem<
  T extends NavigationPanelTrashCapabilityItem,
> = T & {
  entity: Extract<AffineDNDEntity, { type: 'doc' | 'folder' }>;
};

export function isNavigationPanelTrashableSelectionItem<
  T extends NavigationPanelTrashCapabilityItem,
>(item: T): item is NavigationPanelTrashableSelectionItem<T> {
  if (item.entity.type === 'doc') {
    return item.docTrash?.canTrashDoc === true;
  }

  if (item.entity.type === 'folder') {
    return item.folderTrash?.canTrashFolder === true;
  }

  return false;
}

export function filterNavigationPanelBlockedTrashSelectionItems<
  T extends NavigationPanelTrashCapabilityItem,
>(items: readonly T[]): T[] {
  return items.filter(
    item =>
      (item.entity.type === 'doc' || item.entity.type === 'folder') &&
      !isNavigationPanelTrashableSelectionItem(item)
  );
}

export function filterNavigationPanelTrashableSelectionItems<
  T extends NavigationPanelTrashCapabilityItem,
>(items: readonly T[]): NavigationPanelTrashableSelectionItem<T>[] {
  return items.filter(isNavigationPanelTrashableSelectionItem);
}
